var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArgentx(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.6794 19H45.3205C44.6067 19 44.0349 19.6092 44.0193 20.3665C43.5878 41.6523 33.0936 61.855 15.0309 76.1647C14.4574 76.6188 14.3268 77.4723 14.746 78.087L27.2428 96.4236C27.6679 97.0477 28.4963 97.1885 29.0794 96.7301C40.3735 87.8411 49.4579 77.1179 55.9999 65.2324C62.542 77.1179 71.6269 87.8411 82.921 96.7301C83.5036 97.1885 84.3319 97.0477 84.7576 96.4236L97.2544 78.087C97.6731 77.4723 97.5424 76.6188 96.9695 76.1647C78.9063 61.855 68.4121 41.6523 67.981 20.3665C67.9655 19.6092 67.3931 19 66.6794 19Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6027 32.2766L94.327 25.2459C93.8641 23.8185 92.7367 22.7067 91.3015 22.2671L84.2367 20.0951C83.2618 19.7951 83.2515 18.4169 84.2237 18.104L91.2524 15.8286C92.6798 15.3657 93.7944 14.2358 94.234 12.8032L96.4035 5.73892C96.7035 4.7615 98.0819 4.75114 98.3973 5.72343L100.673 12.7541C101.136 14.1814 102.263 15.2933 103.698 15.7355L110.763 17.9049C111.738 18.2049 111.749 19.5831 110.776 19.8986L103.748 22.174C102.32 22.6343 101.206 23.7643 100.766 25.1994L98.5964 32.2611C98.2965 33.2385 96.9182 33.2488 96.6027 32.2766Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArgentx);
export default __webpack_public_path__ + "static/media/argentx.f15de807445aee3367208b08c5d0b9e0.svg";
export { ForwardRef as ReactComponent };